import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

import { imageMapsRequest, deleteImageMapsRequestCompleted } from '../actions';

const { takeEvery, put, take } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        for (const lang of config.app.languages) {
            const ref = yield firestore.doc(`languages/${lang}/imageMaps/${meta.id}`);
            yield ref.delete();
        }
        message.success(intl.formatMessage({ id: 'success.maps.image.delete' }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.maps.image.delete' }));
    } finally {
        yield put(imageMapsRequest({ silent: true }));
        yield take(types.IMAGE_MAPS_REQUEST_COMPLETED);
        yield put(deleteImageMapsRequestCompleted(meta.id));
    }
}
export default function* () {
    yield takeEvery(types.DELETE_IMAGE_MAP_REQUEST, handler);
}
